import { IMenuOption } from "models/interfaces";
import React, { useState } from "react";
import InvoiceDetailModal from "./InvoiceDetail/InvoiceDetailModal";

const ViewInvoiceDetail: React.FC<{
  setShowMenu: Function;
  invoiceId: number;
  setSelectedMenuId: Function;
  menuData: IMenuOption
}> = ({
  setShowMenu,
  invoiceId,
  setSelectedMenuId,
  menuData
}) => {
    const [ifShowInvoiceDetailModal, setIfShowInvoiceDetailModal] = useState<boolean>(false);

    return (
      <React.Fragment>
        <div
          className="accHead"
          onClick={() => {
            setSelectedMenuId(null);
            setIfShowInvoiceDetailModal(!ifShowInvoiceDetailModal);
            setShowMenu(false);
          }
          }
        >
          {menuData.name}
        </div>
        <InvoiceDetailModal
          ifShowInvoiceDetailModal={ifShowInvoiceDetailModal}
          setIfShowInvoiceDetailModal={setIfShowInvoiceDetailModal}
          invoiceId={invoiceId}
        />
      </React.Fragment>
    );
  };

export default ViewInvoiceDetail;
